<template>
  <div class="page">
    <div class="up-info">
      <div class="info-title">线下扫码-<span v-if="!bindOrUnbind">已绑定</span>
        <span v-else>推荐</span>二维码列表
      </div>
      <div class="info-active">
        <div class="left">
          <div class="left-img">
            <div id="qrcode"></div>
          </div>
          <div class="right-des">
            <div style="font-size: 18px;font-weight: bold">{{ project.title }}</div>
            <div style="font-size: 16px">{{ project.description }}</div>
          </div>
        </div>
        <div class="right">
          <el-button v-if="!bindOrUnbind" type="primary" @click="checkoutData">添加二维码</el-button>
          <el-button v-else type="danger" @click="checkoutData">解绑二维码</el-button>
        </div>
      </div>
    </div>
    <div class="middle-search">
      <el-input style="width: 300px" v-model="merchantPhone" placeholder="输入商户电话查询二维码" clearable
                @clear="initselectAll"></el-input>
      <el-button style="margin-left: 3%" type="primary" @click="searchByPhone">搜索</el-button>
      <el-select style="margin-left: 3%" v-model="qrcodeDistrict" clearable placeholder="筛选区域" @change="changeDistrict"
                 @clear="initselectAll">
        <el-option
          v-for="item in area"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>
    <hr/>
    <el-table v-loading="loadData"
              element-loading-text="数据源切换中......"
              element-loading-background="rgba(0, 0, 0, 0.8)"
              v-if="!bindOrUnbind" :data="qrcodeData" @selection-change="selectionChange">
      <el-table-column type="selection" align="center"></el-table-column>
      <el-table-column label="参数" prop="param" align="center"></el-table-column>
      <el-table-column label="商户" prop="shopPhone" align="center"></el-table-column>
      <el-table-column label="消耗金额" align="center">
        <template slot-scope="amountslot">
          <span v-if="amountslot.row.amount">{{amountslot.row.amount}}</span>
          <span v-else>0</span>
        </template>
      </el-table-column>
      <el-table-column label="累计扫码" prop="version" align="center"></el-table-column>
      <el-table-column label="区域" prop="district" align="center"></el-table-column>
      <el-table-column label="距离" align="center">
        <template slot-scope="scope0">
          <span v-if="scope0.row.distance">{{ scope0.row.distance }}米</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope1">
          <el-button @click="delBind(scope1.row)">解除绑定</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-table v-loading="loadData"
              element-loading-background="rgba(0, 0, 0, 0.8)"
              element-loading-text="数据源切换中......"
              v-else :data="recommendData"
              @selection-change="selectionChange"
              @sort-change="sortChange"
    >
      <el-table-column type="selection" align="center"></el-table-column>
      <el-table-column label="参数" prop="param" align="center"></el-table-column>
      <el-table-column label="商户" prop="shopPhone" align="center"></el-table-column>
      <el-table-column label="已绑定" prop="bindings" align="center" sortable="custom">
        <template slot-scope="bindslot">
          <span>{{bindslot.row.bindings}}</span>
        </template>
      </el-table-column>
      <el-table-column label="累计扫码" prop="scanNum" align="center" sortable="custom"></el-table-column>
      <el-table-column label="区域" prop="district" align="center"></el-table-column>
      <el-table-column label="距离" align="center">
        <template slot-scope="scope0">
          <span v-if="scope0.row.distance">{{ scope0.row.distance }}米</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope1">
          <el-button @click="Bind(scope1.row)">绑定</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-button v-if="!bindOrUnbind" type="primary" class="button-class" @click="showQrcodeList">批量解绑</el-button>
    <el-button v-else type="primary" class="button-class" @click="showQrcodeList">批量绑定</el-button>
    <el-pagination
      style="text-align: center;margin-top: 1%"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    <el-dialog :visible.sync="showUnbindDialog" width="50%" title="提示" @close="showUnbindDialog=false"
               :close-on-click-modal="false">
      <span style="font-size: 15px;font-weight: bold">以下二维码将与"{{project.title}}"解除绑定</span>
      <el-table ref="qrcodeInfo" :data="selected">
        <el-table-column type="selection" align="center"></el-table-column>
        <el-table-column label="序号" type="index" align="center"></el-table-column>
        <el-table-column label="店铺名称" prop="shopName"></el-table-column>
      </el-table>
      <div align="right" style="margin-top: 5%">
        <el-button @click="showUnbindDialog=false">取消</el-button>
        <el-button type="primary" @click="builkCancleBind">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="singleBind" width="500px" title="绑定" @close="singleBind=false"
               :close-on-click-modal="false">
      <el-form>
        <el-form-item label="必出:">
          <el-switch
            v-model="certainlyOut"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="是"
            inactive-text="否"
            active-value=1
            inactive-value=0
          ></el-switch>
        </el-form-item>
        <el-form-item align="right">
          <el-button @click="cancleBind">取消</el-button>
          <el-button type="primary" @click="confirmSingleBind">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import {area} from './fixation.js'
  import QRCode from 'qrcodejs2'

  export default {
    name: "active-bind-qrcode",
    data() {
      return {
        area: area,
        qrcodeDistrict: '',
        qrcodeData: null,
        merchantPhone: '',
        currentPage: 1,
        pageSize: 10,
        total: 0,
        project: {},
        selected: [],
        showUnbindDialog: false,
        bindOrUnbind: false,  // false 代表unBind(解绑) true代表新增绑定
        loadData: false,
        recommendData: null,
        singleBind: false,
        certainlyOut: null,
        singleBindRow: null,
        showBindDialog: false,
      }
    },
    methods: {
      initselectAll() {
        this.loadData = true
        let param = {
          project: this.project.id,
          phone: this.merchantPhone,
          district: this.qrcodeDistrict,
          pageSize: this.pageSize,
          currentPage: this.currentPage - 1
        }
        if (!this.bindOrUnbind) {
          this.$http.post(this, '/qrcode/getQrcodeForActive', param).then(res => {
            this.total = res.data.count
            this.qrcodeData = res.data.data
          })
        } else {
          this.$http.post(this, '/qrcode/getRecommendQrcodeList', param).then(res => {
            this.total = res.data.count
            this.recommendData = res.data.data
          })
        }
        this.loadData = false
      },
      changeDistrict() {
        this.currentPage = 1
        this.merchantPhone = ''
        this.initselectAll()
      },
      searchByPhone() {
        this.currentPage = 1
        this.qrcodeDistrict = ''
        this.initselectAll()
      },
      builkCancleBind() {
        let ids = []
        this.selected.forEach(item => {
          if (!this.bindOrUnbind) {
            ids.push(item.id)
          } else {
            ids.push(item.param)
          }
        })
        if (ids.length == 0) {
          return
        }
        if (!this.bindOrUnbind) {
          this.$http.post(this, '/qrcode/batchUnbinding', {activeId: this.project.id}, ids).then(res => {
            this.$message({
              message: res.code == 200 ? '解绑成功！' : '解绑失败！',
              type: res.code == 200 ? "success" : "error"
            })
            this.showUnbindDialog = false
            this.initselectAll()
          })
        } else {
          this.$http.post(this, '/qrcode/batchBinding', {activeId: this.project.id}, ids).then(res => {
            this.$message({
              message: res.code == 200 ? '绑定成功！' : '绑定失败！',
              type: res.code == 200 ? "success" : "error"
            })
            this.showUnbindDialog = false
            this.initselectAll()
          })
        }
      },
      selectionChange(val) {
        this.selected = val
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.initselectAll()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.initselectAll()
      },
      delBind(row) {
        this.$confirm('确认解除绑定？').then(res => {
          this.$http.post(this, '/qrcode/active/delete', {id: row.id}).then(res => {
            this.$message({
              message: res.code == 200 ? res.data : res.message,
              type: res.code == 200 ? "success" : "error"
            })
            this.initselectAll()
          })
        }).catch(e => {
          console.log(e);
          return
        })
      },
      initProjectInfo() {
        let that = this
        this.project.id = this.$route.query.id
        this.project.title = this.$route.query.title
        this.project.description = this.$route.query.description
        this.project.resource = this.$route.query.resource
        setTimeout(function () {
          that.loadQrcode()
        }, 1000)
      },
      qrcode(qrurl) {
        new QRCode('qrcode', {
          width: 100,
          height: 100,        // 高度
          text: process.env.CONFIG.frontUrl + 'share/' + qrurl,   // 二维码内容
        })
      },
      loadQrcode() {
        if (this.$route.query.sn) {
          this.project.sn = this.$route.query.sn
          this.qrcode(this.$route.query.sn)
        } else {
          this.project.sn = null
        }
      },
      showQrcodeList() {
        if (this.selected.length == 0) {
          return
        }
        this.showUnbindDialog = true
        this.defaultSelection()
      },
      defaultSelection() {
        // 默认全选
        let that = this
        setTimeout(function () {
          that.selected.forEach(item => {
            that.$refs.qrcodeInfo.toggleRowSelection(item, true)
          })
        }, 1)
      },
      checkoutData() {
        this.currentPage = 1
        this.bindOrUnbind = !this.bindOrUnbind
        this.initselectAll()
      },
      Bind(row) {
        this.singleBindRow = row
        this.singleBind = true
      },
      confirmSingleBind() {
        let param = {
          param: this.singleBindRow.param,
          projectId: this.project.id,
          certainlyOut: this.certainlyOut
        }
        this.$http.post(this, '/qrcode/bindActive', param).then(res => {
          this.$message({
            message: res.code == 200 ? res.data : res.message,
            type: res.code == 200 ? "success" : "error"
          })
          this.singleBind = false
          this.certainlyOut = 0
          this.initselectAll()
        })
      },
      cancleBind() {
        this.certainlyOut = 0
        this.singleBind = false
      },
      sortChange(column, prop, order) {
        console.log(column);
        // console.log(prop);
        // console.log(order);
      },
    },
    created() {
      this.initProjectInfo()
      this.initselectAll()
    }
  }
</script>

<style scoped>
  .page {
    width: 100%;
    height: 100%;
  }

  .up-info {
    width: 100%;
    height: 30%;
  }

  .info-title {
    font-size: 30px;
    font-weight: bold;
  }

  .info-active {
    padding: 1% 0px;
    width: 100%;
    display: flex;
  }

  .left {
    display: flex;
    width: 100%;
  }

  .left-img {
    width: 100px;
  }

  .right {
    width: 100%;
  }

  .right-des {
    padding: 0px 4%;
  }

  .left-img img {
    border-radius: 7px;
    width: 100%;
  }

  .button-class {
    margin-top: 1%;
    margin-left: 1.2%;
  }
</style>
